import React, { useEffect, useState } from "react";
import styles from "./poc.module.css";
import { TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAllProduct } from "../api-context/commonApiContext";
import config from "../../config/config";
import { CircularProgress } from "@mui/material";

const isValidIndianPhone = (raw = "") => {
  const v = String(raw).trim();
  // Accept: +91XXXXXXXXXX / +91 XXXXX XXXXX / 0XXXXXXXXXX / XXXXXXXXXX
  // Must be 10 digits starting 6-9 after removing +91/00 91/0 and spaces/dashes
  const cleaned = v.replace(/[\s-]/g, "");
  // Strip common prefixes
  const withoutPrefix = cleaned
    .replace(/^(?:\+91|0091|091)/, "")
    .replace(/^0/, "");
  return /^[6-9]\d{9}$/.test(withoutPrefix);
};

const normalizeIndianPhone = (raw = "") => {
  const cleaned = String(raw).trim().replace(/[\s-]/g, "");
  const noCountry = cleaned.replace(/^(?:\+91|0091|091)/, "").replace(/^0/, "");
  // Return normalized E.164 (+91XXXXXXXXXX)
  if (/^[6-9]\d{9}$/.test(noCountry)) {
    return `${noCountry}`;
  }
  return raw; // fallback (won't be used if we validate first)
};

const Poc = () => {
  const navigate = useNavigate();
  const {
    setCompanyId,
    isAllowAdvancedKyc,
    setPhoneNo,
    setName,
    setEmail,
    phoneNo,
    email,
    name,
    setAffiliate_code,
  } = useAllProduct();

  useEffect(() => {
    isAllowAdvancedKyc(false);
  }, []);
  const [affiliate_code, setAffiliate_Code] = useState();
  const [form, setForm] = useState({
    name: name?.length > 0 ? name : "",
    number: phoneNo?.length > 0 ? phoneNo : "",
    email: email?.length > 0 ? email : "",
  });

  const [errors, setErrors] = useState({
    name: "",
    number: "",
    email: "",
  });

  const [submitting, setSubmitting] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "number") {
      // Keep only digits
      const onlyDigits = value.replace(/\D/g, "");
      // Limit to 10 digits
      if (onlyDigits.length <= 10) {
        setForm((prev) => ({ ...prev, [name]: onlyDigits }));
      }
    } else if (name === "name") {
      const cleaned = value.replace(/^\s+/, "").replace(/[^a-zA-Z\s]/g, "");
      setForm((prev) => ({ ...prev, [name]: cleaned }));
    } else {
      const noLeadingSpace = value.replace(/^\s+/, "");
      setForm((prev) => ({ ...prev, [name]: noLeadingSpace }));
    }

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const isValidEmail = (email = "") => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  function cleanAndUpper(str) {
    return str?.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  }

  const handleNext = async () => {
    const newErrors = { name: "", number: "", email: "" };
    let valid = true;

    // Name: required, min length 3 (after trim)
    const nameTrim = (form.name || "").trim();
    if (!nameTrim) {
      newErrors.name = "Please enter your name.";
      valid = false;
    } else if (nameTrim.length < 3) {
      newErrors.name = "Name must be at least 3 characters.";
      valid = false;
    }

    // Phone: required, Indian pattern
    const phoneTrim = (form.number || "").trim();
    if (!phoneTrim) {
      newErrors.number = "Please enter your phone number.";
      valid = false;
    } else if (!isValidIndianPhone(phoneTrim)) {
      newErrors.number =
        "Enter a valid Indian mobile number (e.g., 9876543210 or +91 98765 43210).";
      valid = false;
    }

    // Email (optional)
    const emailTrim = (form.email || "").trim();
    if (emailTrim && !isValidEmail(emailTrim)) {
      newErrors.email = "Please enter a valid email address.";
      valid = false;
    }

    setErrors(newErrors);
    if (!valid) return;

    try {
      setSubmitting(true);
      let newAffiliateCode = cleanAndUpper(affiliate_code);
      setAffiliate_code(newAffiliateCode ? newAffiliateCode : null);
      const normalizedPhone = normalizeIndianPhone(phoneTrim);
      const payload = {
        name: nameTrim,
        phone_number: normalizedPhone,
        email: (form.email || "").trim(),
        affiliate_code: newAffiliateCode,
      };
      console.log("---------payload--------", payload);

      setPhoneNo(normalizedPhone);
      setName(nameTrim);
      setEmail(emailTrim);

      const res = await fetch(`${config.mock_api_endpoint}/user-detail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-API-Key": process.env.REACT_APP_CUPI_API_KEY,
        },
        body: JSON.stringify(payload),
      });

      const raw = await res.text();
      if (!res.ok)
        throw new Error(raw || `Request failed with status ${res.status}`);

      const data = (() => {
        try {
          return JSON.parse(raw);
        } catch {
          return {};
        }
      })();
      console.log("test-->", data);

      setCompanyId(data?.data?.company_id);
      if (data?.data?.company_id)
        localStorage.setItem("company_id", data?.data?.company_id);

      navigate("/basic-kyc/verify");
    } catch (err) {
      console.error("❌ POST /user-detail failed:", err);

      // Try to extract message safely
      let message = "Something went wrong";
      try {
        // If your backend sends { success, message }
        if (err?.response?.data?.message) {
          message = err.response.data.message;
        } else if (err?.message) {
          // err.message could be a JSON string
          try {
            const parsed = JSON.parse(err.message);
            message = parsed.message || message;
          } catch {
            message = err.message;
          }
        }
      } catch (e) {
        console.warn("Failed to parse error message", e);
      }

      setErrMsg(message);

      setErrors((prev) => ({
        ...prev,
        // email: "Could not save details. Please try again.",
      }));
    } finally {
      setSubmitting(false);
    }
  };
  console.log("error-->", errMsg);

    return (
    <>
      <div className={`${styles.wrapper} container`}>
        {submitting && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(255,255,255,0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 2000,
            }}
          >
            <CircularProgress size={60} sx={{ color: "#2348AB" }} />
          </div>
        )}

        <div className={styles.NoteContainer}>
          To signup for your CUPI Account, provide the details of your Company
          representative here.
        </div>
        <div className={styles.title}>Point of Contact Information</div>
        <hr />
        <div className={styles.NoteContainer2}>
          <span className={styles.Bold}>Note:</span> Please be aware that you
          will only have CUPI Dashboard Owner access for the name and phone
          number you provide here.
        </div>
        <div className="d-flex justify-content-between gap-3 mt-4">
          <TextField
            className="w-50"
            name="name"
            label={
              <>
                Full name as per PAN<span style={{ color: "red" }}> *</span>
              </>
            }
            value={form.name}
            onChange={handleChange}
            variant="outlined"
            error={!!errors.name}
            helperText={errors.name}
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
            inputProps={{ maxLength: 80 }}
          />
          <div className="w-50">
            <TextField
              className="w-100"
              name="number"
              label={
                <>
                  Phone No<span style={{ color: "red" }}> *</span>
                </>
              }
              value={form.number}
              onChange={handleChange}
              variant="outlined"
              error={!!errors.number}
              helperText={errors.number}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
              type="tel"
              inputMode="numeric"
              placeholder="Enter phone number"
              inputProps={{ maxLength: 10 }} // safeguard
            />
          </div>
        </div>

        <div className="d-flex justify-content-between gap-3 mt-4">
          <div className="w-50">
            <TextField
              className="w-100"
              name="email"
              label="Email ID (optional )"
              value={form.email}
              onChange={handleChange}
              variant="outlined"
              error={!!errors.email}
              helperText={errors.email}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
            />
          </div>

          <div className="w-50">
            <TextField
              className="w-100"
              name="affiliate_code"
              label="Referral / Affiliate Code(optional)"
              value={affiliate_code}
              onChange={(e) => {
                let newText= cleanAndUpper(e.target.value)
                setAffiliate_Code(newText);
              }}
              inputProps={{ maxLength: 30 }}
              variant="outlined"
              // error={affiliate_code}
              // helperText={cleanAndUpper(affiliate_code)}
              sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
            />
          </div>
        </div>
        {errMsg?.length > 0 && (
          <span style={{ color: "red", fontSize: "20px", marginTop: 20 }}>
            {errMsg}
          </span>
        )}
        <div className="d-flex justify-content-end">
          <button
            className={`${styles.nextBtn} d-flex justify-content-end px-5 pt-2 pb-2 mt-4`}
            onClick={handleNext}
            disabled={submitting}
          >
            {submitting ? "Saving..." : "Next"}
          </button>
        </div>
      </div>
    </>
  );
};

export default Poc;
